<template>
  <el-dialog
    top="15vh"
    class="device-edit__dialog"
    :title="$t('Other.register')"
    width="600px"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="100px"
      size="small"
      label-suffix=": "
    >
      <el-form-item :label="$t('Device.deviceCode')">
        {{ form.code }}
      </el-form-item>
      <el-form-item :label="$t('Device.customerName')" prop="customerId">
        <!--        <el-input v-model="form.customerName" :placeholder="$t('Device.customerName')"> </el-input>-->
        <Select
          :query="`${$api.common.customer_select}`"
          v-model="form.customerId"
          :placeholder="$t('Device.customerName')"
        >
        </Select>
      </el-form-item>
      <el-form-item :label="$t('Device.warrantyPeriod')" prop="warrantyPeriod">
        <el-input
          v-model="form.warrantyPeriod"
          :placeholder="$t('Device.warrantyPeriod')"
          oninput="value=value.replace(/[^0-9]/g,'')"
          @blur="limitMaxvalue"
        >
        </el-input>
        <span style="margin-left:8px">{{ $t('Device.unitDay') }}</span>
      </el-form-item>
      <el-form-item :label="$t('Device.installationTime')" prop="installationTime">
        <el-date-picker
          v-model="form.installationTime"
          type="date"
          :placeholder="$t('Device.installationTime')"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('Device.installationArea')" prop="installationArea">
        <el-cascader
          clearable
          ref="cascaderAddr"
          v-model="form.installationArea"
          :placeholder="$t('Device.installationArea')"
          :options="areaOptions"
          :props="{
            checkStrictly: false,
            children: 'child',
            value: 'code',
            label: 'name'
          }"
          filterable
          @change="handleInstallArea"
        >
        </el-cascader>
        <el-input
          style="margin-top: 8px;width: 280px"
          type="textarea"
          :rows="4"
          v-model="form.installationAreaDetail"
          :placeholder="$t('Device.installationAreaDetail')"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="edit-footer">
      <hl-button type="border" @click="close">{{ $t('Common.cancel') }}</hl-button>
      <hl-button @click="save" :loading="loading">{{ $t('Common.save') }}</hl-button>
    </div>
  </el-dialog>
</template>

<script>
import { formatTime } from '@/utils/utils'
import Select from '@/components/CommonForm/Select'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },
  components: {
    Select
  },
  data() {
    return {
      areaOptions: [],
      form: {
        installationArea: [],
        code: ''
      },
      rules: {
        // name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        warrantyPeriod: [
          { required: true, message: this.$t('Device.warrantyPeriod'), trigger: 'blur' }
        ],
        installationTime: [
          { required: true, message: this.$t('Device.installationTime'), trigger: 'change' }
        ],
        installationArea: [
          { required: true, message: this.$t('Device.installationArea'), trigger: 'change' }
        ]
      },
      loading: false
    }
  },
  created() {
    this.getArea()
    if (this.row.id && this.visible) {
      console.log(this.row)
      this.form = {
        code: this.row.code,
        installationArea: []
      }
    }
  },
  methods: {
    formatTime,
    limitMaxvalue(e) {
      if (e.target.value && parseInt(e.target.value) > 36500) {
        this.$set(this.form, 'warrantyPeriod', '0')
      }
    },
    handleInstallArea(val) {
      this.$nextTick(()=>{
        let value = this.$refs.cascaderAddr.getCheckedNodes()[0].pathLabels
        this.$set(this.form, 'installationAreaName', value)
      })
    },
    getArea(data = {}) {
      const api = this.$api.common.area_select
      let params = {
        ...data,
        language: localStorage.getItem('locale')
      }
      this.$ajax
        .get(api, params)
        .then((res) => {
          this.areaOptions = res.data
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    close() {
      this.$emit('update:visible', false)
    },
    handleProductChange(product) {
      this.form.productName = product.name
    },
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      return pass
    },
    save() {
      if (!this.checkForm()) return
      this.loading = true
      let params = {
        code: this.form.code,
        customerId: this.form.customerId,
        warrantyPeriod: this.form.warrantyPeriod,
        installationTime: this.form.installationTime,
        installationArea: this.form.installationArea.join(','),
        installationAreaName: this.form.installationAreaName.join(','),
        installationAreaDetail: this.form.installationAreaDetail
      }
      let api = this.$api.device.device_add
      this.$ajax
        .post(api, params)
        .then(() => {
          this.$message.success(`${this.$t('Common.operationSuccess')}`)
          this.close()
          this.$emit('refresh')
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.device-edit__dialog {
  /deep/ {
    .el-dialog__body {
      padding-left: 40px;
    }
  }
  .el-form-item:last-child {
    margin-bottom: 0;
  }
}
</style>
